"use strict";
exports.__esModule = true;
exports.ChainFactory = void 0;
var utils_1 = require("../utils");
var validation_1 = require("../validation");
exports.ChainFactory = {
    createInstance: function (params) {
        return {
            uuid: utils_1.UUIDs.v4(),
            props: params,
            validation: validation_1.ValidationFactory.createInstance({})
        };
    }
};
//# sourceMappingURL=chainFactory.js.map